
import { FormattedMessage } from 'react-intl';

import './style.scss';

export function Elite() {
  return (
    <div className="elite-rci-how-to">
      <section className="pt-xs-32 pb-xs-24 pt32" style={{ maxWidth: '1020px', margin: '0 auto' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 divider">
              <p className="h4" style={{ fontFamily: 'arial', color: '#000', fontStyle: 'italic' }}>
                <FormattedMessage id={'elite.message.1'} values={{ strong: (message: string) => (<strong>{message}</strong>) }} />
              </p>
            </div>
          </div>
        </div>

      </section>
    </div>
  );
}
